import { api_configuration } from "../../common";
import api_gui_model = api_configuration.libraries.gui_definition_lib.types.settings.alan_api;
import tryToOpenViewFromUrl from "./tryToOpenViewFromUrl";

let popStateEventListener: (() => void) | undefined = undefined;
export function startListening(target_window: api_gui_model.Cwindows) {
	stopListening();
	popStateEventListener = () => {
		tryToOpenViewFromUrl(target_window);
	};
	setTimeout(popStateEventListener, 0);
	window.addEventListener("popstate", popStateEventListener);
}

export function stopListening() {
	if (popStateEventListener === undefined) return;
	window.removeEventListener("popstate", popStateEventListener);
	popStateEventListener = undefined;
}
